import React from 'react'
import styled from 'styled-components'
import CompFlatTable from '@src/modules/SiteResoureRequirements/comps/FlatTable'
import FormPanel from '@src/components/FormPanel/FormPanel'
import { MaterialAsphaltOtherProduct } from '@src/types/MaterialAsphaltOtherProduct'
import useModal from '@src/components/FormModal/useModal'
import Modal from '@src/components/FormModal/Modal'
import { useSRR } from '@src/modules/SiteResoureRequirements/useSRR'
import fields from './fields'
import { useParams } from 'react-router'
import { useAppStore } from '@src/AppStore'
import { useSnackbar } from '@src/components/GlobalSnackbar'
import { apiSrrMaterialOtherProductUpdate } from '@src/apis/srr-material-other-product-update'
import { JobType } from '@src/types/JobType'
import usePermission from '@src/utils/hooks/usePermission'

interface Props {

}

const CompAsOther = (props: Props) => {
  const {

  } = props
  const { id } = useParams<{id: string}>()
  const { serialId } = useAppStore()
  const [ srr, srrLoading, refresh ] = useSRR()
  const { alert } = useSnackbar()
  const [ open, modalData, openAndSetData, closeModal ] = useModal<MaterialAsphaltOtherProduct>({})
  const { canEditSubmitSRR } = usePermission()

  if (srr === null) {
    return null
  }
  const product = srr.material.asphalt.otherProducts
  const handleSave = async (form: any) => {
    console.log(form)
    try {
      const result = await apiSrrMaterialOtherProductUpdate({
        srrId: id, 
        serialId,
        jobType: JobType.Asphalt,
        partialProduct: {
          ...form,
        }
      })
      alert({
        message: `Done.`
      })
      refresh()
      closeModal()
    } catch (e) {
      alert({
        type: 'error',
        message: `Error.`
      })
    }
  }
  return <Wrapper>
    <FormPanel 
      title={`Other Asphalt Products`}
    >
      <CompFlatTable<MaterialAsphaltOtherProduct>
        data={product}
        fields={fields}
        editable={canEditSubmitSRR}
        onEdit={() => {
          openAndSetData(product)
        }}
      />
    </FormPanel>
    { open && <Modal<MaterialAsphaltOtherProduct>
        maxWidth='md'
        open={open}
        title='Other Materials Asphalt'
        data={{
          rowData: modalData,
          fields: fields,
          columns: [
            {
              title: '',
              fieldKeys: [
                'grit', 
                'tipFees', 
                'dialBeforeYouDig',
                'glassGrid',
                'crackSealingDrums',
                'catEyeCovers', 
              ],
            },
            {
              title: '',
              fieldKeys: [
                'trafficLoops',
                'hateliteBitac',
                'roadBase', 
                'sticksNStomps', 
                'dryIce', 
              ],
            },
            {
              title: '',
              fieldKeys: [
                'geoFabric',
                'emulsion',
              ],
            },
          ]
        }}
        onSuccess={handleSave}
        onClose={closeModal}
        onCancel={closeModal}
      /> 
    }
  </Wrapper>
}

const Wrapper = styled.div`

`

export default CompAsOther